<template>
    <div class="page" id="page_Forte">
        <div class="inner">
            <img src="images/forte2.png" alt="Forte" height="203" width="70" />
            <h1>Forte</h1>
            <span><b>M</b><i>.</i>eetings</span>
            <span><b>I</b><i>.</i>ncentives</span>
            <span><b>C</b><i>.</i>onventions</span>
            <span><b>E</b><i>.</i>vents</span>
        
            <span class="box2">Where Events Meet the World</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Forte'
}
</script>

<style lang="less" scoped>
h1 {
    color: @forteRed;
    display: block;
    font-family: @defaultFontFamily;
    font-weight: bold;
    font-size: 2.857em;
    line-height: 1em;
    margin: 0 0 0.214em;
    text-transform: uppercase;
}
span {
    color: @lightColor;
    font-weight: bold;
    font-size: 2em;
    line-height: 1em;
    margin: 0 0 0.214em;
    text-transform: uppercase;
}
img {
    display: block;
    margin: 0 auto 25px;
}
b,i {
    color: #999;
}
.box2 {
    align-self: center;
    border: 5px solid @lightColor;
    font-size: 1em;
    line-height: 1.2;
    margin-top: 0.5em;
    padding: 0.70em 0.429em;
    text-align: center;
    width: 100%;
}

#page_Forte {
    // .boxPadding;
    // padding-left: 10%;
    // padding-right: 10%;
    min-height: 100vh;

    display: flex;
    flex-direction: row;
    justify-content: center;

    .inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        
        width: auto;
    }
    
}
</style>